import { Grid, Divider, Typography } from '@mui/material';
import { MatchPlayer } from 'app/interfaces/entity';
import { PlayerTile } from 'modules/users/components/PlayerTile/PlayerTile';
import React, { FC } from 'react';
import { PlayerIndexFormat } from 'shared/components/Format/PlayerIndexFormat';
import { useStyles } from './MatchResultSummaryCard.styles';
import { GameCurrency } from 'modules/game-payments/components';

interface MatchResultSummaryCardProps {
  player: MatchPlayer;
  score: number;
  index: number;
  winnings: number;
}

export const MatchResultSummaryCard: FC<MatchResultSummaryCardProps> = ({
  player,
  score,
  index,
  winnings,
}) => {
  const { classes } = useStyles();

  if (!player) {
    return null;
  }

  return (
    <>
      <Grid container spacing={0} className={classes.headerContainer}>
        <Grid item xs={5}>
          <Typography>
            <PlayerIndexFormat index={index} />
          </Typography>
        </Grid>
        <Grid item xs={3.5} className={classes.justifyCenter}>
          <Typography>Score</Typography>
        </Grid>
        <Grid item xs={3.5} className={classes.justifyCenter}>
          <Typography>Winnings</Typography>
        </Grid>
      </Grid>
      <Divider />
      <Grid container spacing={0} className={classes.resultContainer}>
        <Grid item xs={5}>
          <PlayerTile user={player.user} readonly />
        </Grid>
        <Grid item xs={3.5} className={classes.justifyCenter}>
          <Typography>{score}</Typography>
        </Grid>
        <Grid item xs={3.5} className={classes.justifyCenter}>
          <GameCurrency amount={winnings} />
        </Grid>
      </Grid>
    </>
  );
};
